import React from "react"
import Label from "@kit/design/label"
import { ColorInput } from "@kit/design/color-picker"
import Icon from "@kit/design/icon"
import { useSavedColors } from "hooks/use-saved-colors"

export function ClearableColor({
  template,
  update,
  label,
  value,
  htmlFor,
  propertyName
}) {
  const savedColors = useSavedColors()

  function clearColor() {
    update(
      { [propertyName]: null },
      { localStoragePrefix: `layout-${template}` }
    )
  }

  return (
    <>
      <Label htmlFor={htmlFor}>{label}</Label>
      <div className="relative">
        <ColorInput
          id={htmlFor}
          name={htmlFor}
          value={value}
          onChange={color =>
            update(
              { [propertyName]: color.hex },
              { localStoragePrefix: `layout-${template}` }
            )
          }
          savedColors={savedColors}
        />
        {value && (
          <button
            onClick={clearColor}
            className="top-0 right-0 bottom-0 absolute flex align-center items-center p-2 opacity-50 hover:opacity-100 transition-opacity duration-200"
          >
            <Icon name="close" />
          </button>
        )}
      </div>
    </>
  )
}
